module.exports = "/subscriptions/assets/7bb247f3f1ab5b9e58fd8ace5c0a4df3.svg";